// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  apiUrl: 'https://api.dev.apacfinishline.cbre.com',
  apiChinaUrl: 'https://api.chinadev.apacfinishline.cbre.com',
  mockToken: '',
  // tslint:disable-next-line:max-line-length
  ssoLoginUrl: 'https://login.microsoftonline.com/0159e9d0-09a0-4edf-96ba-a3deea363c28/oauth2/v2.0/authorize?response_type=code&response_mode=query&client_id=cb1042af-ee79-4f8f-ad18-28571f1c82d8&redirect_uri=https://dev.apacfinishline.cbre.com/&scope=openid%20profile%20offline_access&state=https://dev.apacfinishline.cbre.com/&nonce=pWp3j5n5NrLPmAPAC',
  ssoCallbackUrl: 'https://dev.apacfinishline.cbre.com/',
  // tslint:disable-next-line:max-line-length
  peopleSoftUrl: 'http://uscdcfin210.cbre.com:8050/psp/finspdev/EMPLOYEE/ERP/c/CB_MENU.PROJECT_GENERAL.GBL',
  recdStatusUrl: 'https://restservice.dev.finishline.cbre.com/',
  periodCount: 180000,
  finishlineurl: 'https://dev.apacfinishline.cbre.com/',
  disableDsfInProd: false,
  gaodeApiKey: '61617fbc485eea5478b886f2a88e0664',
  googleMapsKey: 'AIzaSyC8IIkHbMI9Gx8T8x-0rsWRbvBvWvtu4zM',
  showReports: true,
  billingAmountCalculatorUrl:'https://cbre.sharepoint.com/:x:/r/sites/intra-FinanceCN/Shared%20Documents/Policies%20%26%20Procedures/Contracts%20to%20Cash/1-02%20China%20Finance%20Update/Billing%20Amount%20%20VAT%20Fapiao%20Calculator_ff20221104.xlsx?d=w5b1002e1eb704dcd8597eec8caf81c78&csf=1&web=1&e=ZH6kHg',
  // Datadog configuration
  datadog: {
    clientToken: 'pub92a45221f3a75b62935aa6793d1b5d3a',
    applicationId: '823d105d-740d-469d-ba3b-adaa0235ed2e',
    version: 'release/r26.06.01',
    site: 'cbretest.datadoghq.com',
    service: 'apacfinishline-frontend-dev',
    env: 'dev',
  }
};
